import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const SeoIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51" fill="none">
			<path
				opacity={0.4}
				fill="none"
				stroke="currentColor"
				strokeWidth={3}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M17.8076 25.4999L22.9289 30.6424L33.1926 20.3574"
			/>

			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={3}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M22.8439 5.20618C24.3101 3.95243 26.7114 3.95243 28.1989 5.20618L31.5564 8.09618C32.1939 8.64868 33.3839 9.09493 34.2339 9.09493H37.8464C40.0989 9.09493 41.9476 10.9437 41.9476 13.1962V16.8087C41.9476 17.6374 42.3939 18.8487 42.9464 19.4862L45.8364 22.8437C47.0901 24.3099 47.0901 26.7112 45.8364 28.1987L42.9464 31.5562C42.3939 32.1937 41.9476 33.3837 41.9476 34.2337V37.8462C41.9476 40.0987 40.0989 41.9474 37.8464 41.9474H34.2339C33.4051 41.9474 32.1939 42.3937 31.5564 42.9462L28.1989 45.8362C26.7326 47.0899 24.3314 47.0899 22.8439 45.8362L19.4864 42.9462C18.8489 42.3937 17.6589 41.9474 16.8089 41.9474H13.1326C10.8801 41.9474 9.03137 40.0987 9.03137 37.8462V34.2124C9.03137 33.3837 8.58512 32.1937 8.05387 31.5562L5.18512 28.1774C3.95262 26.7112 3.95262 24.3312 5.18512 22.8649L8.05387 19.4862C8.58512 18.8487 9.03137 17.6587 9.03137 16.8299V13.1749C9.03137 10.9224 10.8801 9.07368 13.1326 9.07368H16.8089C17.6376 9.07368 18.8489 8.62743 19.4864 8.07493L22.8439 5.20618Z"
			/>
		</SvgIcon>
	)
}

export default SeoIconAtom
